import React from 'react';
import { AI_SEARCH_TRACK_LABELS } from '../../constants/aiSearchTrackLabels';
import { LoadingMessage, LOADING_MESSAGE_TEXT } from '../../utils/loadingMessageUtils';
import {
  StatusIndicatorContainer,
  StatusIndicatorDotsRow,
  StatusIndicatorDot,
  StatusIndicatorText,
} from './StatusIndicator.styles';

interface StatusIndicatorProps {
  /** Legacy text passed as children (used as fallback when loadingMessage is null) */
  children?: React.ReactNode;
  /** Dynamic phase-based loading message driven by node_planning_completed SSE events */
  loadingMessage?: LoadingMessage | null;
}

export const StatusIndicator: React.FC<StatusIndicatorProps> = ({ children, loadingMessage }) => {
  const displayText = loadingMessage ? LOADING_MESSAGE_TEXT[loadingMessage] : children;

  return (
    <StatusIndicatorContainer data-track-label={AI_SEARCH_TRACK_LABELS.MESSAGE_LOADING}>
      <StatusIndicatorDotsRow aria-hidden="true">
        <StatusIndicatorDot $size={4} $delayMs={0} />
        <StatusIndicatorDot $size={4} $delayMs={150} />
        <StatusIndicatorDot $size={4} $delayMs={300} />
      </StatusIndicatorDotsRow>
      {/* key drives CSS fade-out/in when the message changes */}
      <StatusIndicatorText key={loadingMessage ?? 'default'} $shimmer={!!loadingMessage} className="t-font-s m-0">
        {displayText}
      </StatusIndicatorText>
    </StatusIndicatorContainer>
  );
};
